// src/components/copilot/blocks/CitationsBlock.js
export default function CitationsBlock({ block, onCitationClick }) {
  return (
    <div className="flex flex-wrap gap-2">
      {block.items.map((it, i) => (
        <button key={i} onClick={() => onCitationClick && onCitationClick(it)}
          className="rounded-lg border border-border bg-card px-3 py-1 text-xs text-muted-foreground hover:bg-muted">
          {it.agent_name || "Call"} #{it.call_observation_id || it.run_id}
        </button>
      ))}
    </div>
  );
}
